import { configureStore, ConfigureStoreOptions, combineSlices } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'

import { api, publicApi } from '@/api'
import chatReducer from '@/store/chat.slice'

export const rootReducer = combineSlices({
  [api.reducerPath]: api.reducer,
  [publicApi.reducerPath]: publicApi.reducer,
  chat: chatReducer,
})

export const createStore = (
  options?: ConfigureStoreOptions['preloadedState'] | undefined,
): ReturnType<typeof configureStore> =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware, publicApi.middleware),
    ...options,
  })

export const store = createStore()

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof rootReducer>

export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()
